import { useTranslation } from "react-i18next";
import { FileDown, FileSpreadsheet } from "lucide-react";
import { NeuPicker } from "../../components/neu/NeuPicker";
import { localName } from "../../lib/localName";

const STATUSES = ["all", "unpaid", "partial", "paid"];

// شريط فلاتر (فرع، حالة، تصنيف) + أزرار تصدير Excel/PDF.
export const BillsFilters = ({ status, setStatus, branchId, setBranchId, category, setCategory,
                              branches = [], categories = [], onExportExcel, onExportPdf }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-4" data-testid="bills-filters">
      <div className="grid gap-3 sm:grid-cols-3">
        <NeuPicker className="sm:col-span-3" testId="bills-branch-filter" value={branchId}
                   onChange={(e) => setBranchId(e.target.value)}>
          <option value="all">{t("acct.bills.filters.allBranches")}</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{localName(b)}</option>)}
        </NeuPicker>
        <NeuPicker className="sm:col-span-3" testId="bills-status-filter" value={status}
                   onChange={(e) => setStatus(e.target.value)}>
          {STATUSES.map((s) => (
            <option key={s} value={s}>
              {s === "all" ? t("acct.bills.filters.allStatuses") : t(`acct.billStatus.${s}`)}
            </option>
          ))}
        </NeuPicker>
        <NeuPicker className="sm:col-span-3" testId="bills-cat-filter" value={category}
                   onChange={(e) => setCategory(e.target.value)}>
          <option value="all">{t("acct.bills.filters.allCategories")}</option>
          {categories.map((c) => <option key={c.code} value={c.code}>{localName(c)}</option>)}
        </NeuPicker>
      </div>
      <div className="flex flex-wrap justify-end gap-3">
        <button data-testid="bills-export-pdf" onClick={onExportPdf}
                className="flex items-center gap-2 rounded-2xl bg-rose-500 px-4 py-2 text-sm font-black text-white shadow-md hover:bg-rose-600">
          <FileDown className="h-4 w-4" /> {t("acct.bills.exportPdf")}
        </button>
        <button data-testid="bills-export-excel" onClick={onExportExcel}
                className="flex items-center gap-2 rounded-2xl bg-emerald-500 px-4 py-2 text-sm font-black text-white shadow-md hover:bg-emerald-600">
          <FileSpreadsheet className="h-4 w-4" /> {t("acct.bills.exportExcel")}
        </button>
      </div>
    </div>
  );
};
